import Vue from 'vue'
import Router from 'vue-router'
import Login from './components/Login.vue'
import Game from './components/Game.vue'             // 模式选择页
import TableRoom from './components/TableRoom.vue'     // 桌台大厅页
import GameBoard from './components/GameBoard.vue'     // 下棋页
import ShareRoom from './components/ShareRoom.vue' 
import { Base64 } from 'js-base64';
import axios from 'axios'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    { path: '/', name: 'Login', component: Login },
    { path: '/mode', name: 'Game', component: Game },
    { path: '/table', name: 'TableRoom', component: TableRoom },
    { path: '/game', name: 'GameBoard', component: GameBoard },
    { path: '/share/:tabid', name: 'ShareRoom', component: ShareRoom }
  ]
})

function authlogin(authinfo) {
  authinfo.username = 'move'
  return new Promise(resolve => {
    axios.post('/gapi/api/login', authinfo)
      .then(res => {
        localStorage.setItem('user', JSON.stringify(res.data.user));
        localStorage.setItem('userinfo', JSON.stringify(authinfo));
        resolve(res.data)
      })
      .catch(err => {
        console.error(err);
    });
  })
}

router.beforeEach(async(to, from, next) => {
  var userStr = localStorage.getItem('user')
  if(to.query.authinfo) 
  {
    // localStorage.setItem('userinfo', to.query.authinfo);
    // console.log(to.query.authinfo,'to.query.authinfo')
    let authinfo = Base64.decode(to.query.authinfo);
    authinfo    =   JSON.parse(authinfo)
    let { user } = await authlogin(authinfo)
    localStorage.setItem('user', JSON.stringify(user));
    userStr = user
  }
  
  console.log(userStr,'userStr')
	if (!userStr && to.name !== 'Login') {
      next({
        name: 'Login', // 跳转到homeName页
      });
  }else if (userStr && to.name === 'Login') {
    // 已登录且要跳转的页面是登录页 判断gid 是否一致
    next({
      name: 'Game', // 跳转到homeName页
    });
  } else {
    next();
  }
});

export default router;